<template>
  <div
    :class="[
      $style.base,
      {
        [$style.clickable]: clickable && !existingAppointmentData.treatwell,
        [$style.smallScreen]: isSmallScreen,
        [$style.isPackage]: isPackage,
        [$style.withIcon]: showIcon
      }
    ]"
  >
    <BaseIconTile
      v-if="showIcon"
      name="cube"
      fullHeight
      v-test="'part-collapsed-card-icon'"
    />
    <div :class="$style.main">
      <slot />
    </div>
    <div :class="$style.side">
      <BaseIcon
        :name="existingAppointmentData.treatwell ? 'treatwell' : 'edit'"
      />
      <div
        v-if="rowAmount > 1"
        :class="$style.dragIcon"
        class="js-drag-handle"
        v-test="'appointment-part-draghandle'"
      >
        <BaseIcon name="drag" />
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { isSmallScreen } from '@/modules/calendar/appointment/helpers.ts';
import { useCreateAppointmentStore } from '@/stores/calendar-create-appointment';
import unleash from '@/unleash';
import { usePartRows } from '../../part-rows';

const { existingAppointmentData } = useCreateAppointmentStore();

const { rows } = usePartRows();
const rowAmount = computed(() => rows.value.length);

const props = withDefaults(
  defineProps<{
    clickable?: boolean;
    isPackage?: boolean;
  }>(),
  {
    clickable: true,
    isPackage: false,
  },
);

const showIcon = computed(
  () =>
    unleash.isEnabled('ServicePackages') &&
    props.isPackage &&
    !isSmallScreen.value,
);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
  gap: $spacing * 0.75;
  padding: $spacing * 0.75;
  position: relative;
}

.clickable {
  cursor: pointer;
}

.main {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  gap: $spacing * 0.5;
}

.side {
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  gap: $spacing * 0.75;
  align-items: center;
  justify-content: center;

  .base.withIcon & {
    position: absolute;
    right: $spacing * 0.5;
    top: $spacing * 1.4;
  }

  .base:not(.withIcon) & {
    margin-right: -6px;
  }

  .base.smallScreen &,
  .base.isPackage & {
    position: absolute;
    right: $spacing * 0.5;
    top: $spacing * 0.75;
  }
}

.dragIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
}
</style>
